<template>
  <div
    class="
      text-white text-center
      font-bold
      rounded-full
      uppercase
      py-[0.8rem]
      transition-colors
      duration-300
    "
    :class="selected ? 'bg-blue' : 'bg-gray'"
  >
    {{ name }}
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    }
  }
};
</script>
